var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.5955C4.31816 14.5955 1.3335 11.6109 1.3335 7.92887C1.3335 4.24754 4.31816 1.26221 8.00016 1.26221C11.6822 1.26221 14.6668 4.24754 14.6668 7.92887C14.6668 11.6109 11.6822 14.5955 8.00016 14.5955ZM8.00016 4.59554C7.82335 4.59554 7.65378 4.66578 7.52876 4.7908C7.40373 4.91583 7.3335 5.0854 7.3335 5.26221V8.59554C7.3335 8.77235 7.40373 8.94192 7.52876 9.06695C7.65378 9.19197 7.82335 9.26221 8.00016 9.26221C8.17697 9.26221 8.34654 9.19197 8.47157 9.06695C8.59659 8.94192 8.66683 8.77235 8.66683 8.59554V5.26221C8.66683 5.0854 8.59659 4.91583 8.47157 4.7908C8.34654 4.66578 8.17697 4.59554 8.00016 4.59554ZM8.00016 11.2622C8.17697 11.2622 8.34654 11.192 8.47157 11.0669C8.59659 10.9419 8.66683 10.7724 8.66683 10.5955C8.66683 10.4187 8.59659 10.2492 8.47157 10.1241C8.34654 9.99911 8.17697 9.92887 8.00016 9.92887C7.82335 9.92887 7.65378 9.99911 7.52876 10.1241C7.40373 10.2492 7.3335 10.4187 7.3335 10.5955C7.3335 10.7724 7.40373 10.9419 7.52876 11.0669C7.65378 11.192 7.82335 11.2622 8.00016 11.2622Z",
    fill: "#26262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b09ec94522f989f748b5b9bd1e6ccd7f.svg";
export { ForwardRef as ReactComponent };